import type { SearchScenarioId } from "owa-search-store";
import { action } from "satcheljs";

export interface SET_SEARCH_TEXT_FOR_SUGGESTIONActionMessage {
    searchTextForSuggestion: string;
    scenarioId: SearchScenarioId;
}
export const setSearchTextForSuggestion: (searchTextForSuggestion: string, scenarioId: SearchScenarioId) => SET_SEARCH_TEXT_FOR_SUGGESTIONActionMessage = action("SET_SEARCH_TEXT_FOR_SUGGESTION", (searchTextForSuggestion: string, scenarioId: SearchScenarioId): SET_SEARCH_TEXT_FOR_SUGGESTIONActionMessage => ({
    searchTextForSuggestion,
    scenarioId,
}));
